import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetCBSA = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CBSA, token);
  return res;
};

export const AddUpdateCBSA = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_UPDATE_CBSA, payload, token);
  return res;
};

export const DeleteCBSA = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_CBSA + id, id, token);
  return res;
};
